import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '../../styles';
import { Button } from '../buttons/button';
import { NoteSuccessfullySent } from '../legacy_notes/note_successfully_sent';
import { SendNoteModal } from './send_note_modal';
import { useSendNoteButton } from '../../hooks/notes/use_send_note_button';
import theme from '../../styles/theme';
/**
 * SendNote consists of a Send Note button and a modal to confirm the send. If note was sent, display a
 * static "Note sent". Button disabled if no text, or if it exceeds the character limit.
 */
export function SendNote() {
    const { closeModal, noteFinalizedYn, disabledYn, openModal, shouldShowModal, sendNoteEnabledYn, } = useSendNoteButton();
    if (!sendNoteEnabledYn)
        return null;
    if (noteFinalizedYn) {
        return _jsx(NoteSuccessfullySent, { style: { width: '9rem' }, text: "Note sent" });
    }
    return (_jsxs(Container, { children: [_jsx(SendNoteButton, { "data-testid": "send-notes-button", disabled: disabledYn, fontSize: "small", onClick: openModal, style: { backgroundColor: theme.colors.white }, variant: "secondary", children: "Send Note" }), _jsx(SendNoteModal, { isOpen: shouldShowModal, closeModal: closeModal })] }));
}
const Container = styled.div ``;
const SendNoteButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.blue50,
    color: theme.colors.blue50,
    height: '2.125rem',
    width: '5.625rem',
}));
//# sourceMappingURL=send_note.js.map